import { render, staticRenderFns } from "./LaunchPad.vue?vue&type=template&id=1274b942&scoped=true&"
import script from "./LaunchPad.vue?vue&type=script&lang=js&"
export * from "./LaunchPad.vue?vue&type=script&lang=js&"
import style0 from "./LaunchPad.vue?vue&type=style&index=0&id=1274b942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274b942",
  null
  
)

export default component.exports